import { render, staticRenderFns } from "./QuemSomosView.vue?vue&type=template&id=55cd4ff6&"
import script from "./quemsomos.js?vue&type=script&lang=js&"
export * from "./quemsomos.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports